import { baseApi } from "api/BaseApi";

import { CheckInMeeting } from "./checkinMeeting.types";

const CHECK_IN_MEETING_BASE = "top/checkin-meeting";

const checkInMeetingApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    checkInMeetingByProduct: build.query<CheckInMeeting, number | string>({
      query: (productId) => ({
        url: `${CHECK_IN_MEETING_BASE}/get_meeting_by_pid/`,
        params: { pid: productId },
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useCheckInMeetingByProductQuery } = checkInMeetingApi;
